import type { NetworkNode, NodeType, RiskLevel } from "../types";

export interface ConnectedNodeView {
  id: string;
  type: NodeType;
  riskLevel: RiskLevel;
}

/**
 * Resolves a node's connection ids to the connected nodes (id/type/riskLevel),
 * preserving connection order and dropping ids that have no matching node.
 */
export function connectedNodes(
  node: NetworkNode,
  all: readonly NetworkNode[],
): ConnectedNodeView[] {
  const byId = new Map(all.map((n) => [n.id, n]));
  const out: ConnectedNodeView[] = [];
  for (const id of node.connections) {
    const found = byId.get(id);
    if (found) {
      out.push({ id: found.id, type: found.type, riskLevel: found.riskLevel });
    }
  }
  return out;
}
